import "./style.scss";
import { FC, useEffect, useState } from "react";
import { AOPUkraineRequestData } from "@/src/types/admissionOffice";
import backForDocUkraineWithPrint from "@/src/assets/admissionOfficePage/back-for-doc-ukraine-with-print.webp";
import backForDocUkraineWithOutPrint from "@/src/assets/admissionOfficePage/back-for-doc-ukraine-without-print.webp";
import type { RequestLetterBasicCountry } from "../requestLetterBasicRegistry";

interface AOPPrevProps {
  country: RequestLetterBasicCountry;
  bodyForPrev: AOPUkraineRequestData;
}

const hasBodyBlocks = (blocks?: string[] | null): boolean => Array.isArray(blocks) && blocks.length > 0;

const AOPPrev: FC<AOPPrevProps> = ({ country, bodyForPrev }) => {
  const [actualBg, setActualBg] = useState(backForDocUkraineWithOutPrint);
  const showPV = hasBodyBlocks(bodyForPrev.bodyPV);
  const showUniversity = hasBodyBlocks(bodyForPrev.secondBody);

  useEffect(() => {
    setActualBg(bodyForPrev.withPrint ? backForDocUkraineWithPrint : backForDocUkraineWithOutPrint);
  }, [bodyForPrev.withPrint]);

  if (!showPV && !showUniversity) {
    return <div className="admission-office-prev-wrapper" />;
  }

  return (
    <div className="admission-office-prev-wrapper">
      {showPV ? (
        <div className={`admission-office-prev ${country} request`}>
          <img className="admission-office-prev-background" src={actualBg} alt="" />
          <div className="admission-office-prev-section number-and-date">
            <span>№ </span>
            <span>від {bodyForPrev.currentDate ? bodyForPrev.currentDate : "-"}</span>
          </div>
          <div className="admission-office-prev-section title">
            <p>ДОВІДКА ЗА ВИМОГОЮ</p>
          </div>
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.bodyPV!.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        </div>
      ) : null}
      {showUniversity ? (
        <div className={`admission-office-prev ${country} request`}>
          <img className="admission-office-prev-background" src={actualBg} alt="" />
          <div className="admission-office-prev-section number-and-date">
            <span>№ </span>
            <span>від {bodyForPrev.currentDate ? bodyForPrev.currentDate : "-"}</span>
          </div>
          <div className="admission-office-prev-section title">
            <p>ДОВІДКА ЗА ВИМОГОЮ</p>
          </div>
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.secondBody!.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AOPPrev;
